export function uid(prefix = "") {
  return (
    prefix +
    Math.random().toString(16).slice(2) +
    "_" +
    Date.now().toString(16)
  );
}